export default "__VITE_ASSET__DH$woWAP__"